import * as core from '../../../../../../../core'
import * as changeImpactWorkstream from '../change-impact-workstream'

export const RESOURCE = {
  payload: {
    description: 'Payroll Accounting',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactWorkstream.RESOURCE.payload.partialId,
    }),
    id: 'Payroll Accounting',
    name: 'Payroll Accounting',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
